import { Button, Form, Input, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import VideoUpload from '../../../Components/Macro/ImgUpload/VideoUpload';
import { useForm } from 'antd/es/form/Form';
import { useAudios } from './AudioStore';
import { useAudioCat } from '../AudioCat/AudioCatState';

function Edit() {

    let { editVideo, ed } = useAudios()
    let { cats, setCats } = useAudioCat()
    let [videoUrl, setVideoUrl] = useState('')
    useEffect(() => {
        setCats()
    }, [])
    let [frm] = useForm()
    useEffect(() => {
        frm.setFieldsValue(ed)
        setVideoUrl(ed.url)
    }, [ed])

    return (
        <>
            <Form
                form={frm}
                name="basic"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                onFinish={(v) => {
                    let data = {
                        ...v,
                        url: videoUrl
                    }
                    editVideo(data)
                }}
                autoComplete="off"
            >
                <Form.Item
                    name="id"
                    hidden={true}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Video nomi"
                    name="name"
                    rules={[
                        {
                            required: true,
                            message: "To'ldirish majburiy",
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Videoni yuklash"
                    name="url"
                >
                    <VideoUpload setVideo={setVideoUrl} />
                </Form.Item>
                <Form.Item
                    label="Kategoriyasi"
                    name="cat_id"
                >
                    <Select>
                        {cats.map((item) => (
                            <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Saqlash
                    </Button>
                </Form.Item>
            </Form>
        </>
    );
}

export default Edit;